import { Box, Button, Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import * as React from 'react';
import { useState } from 'react';
import SubCard from 'ui-component/cards/SubCard';
import BackdropLoader from '../General/Loader';
import SnackBar from '../General/SnackBar';
import { useEffect } from 'react';
import { getHardwareRequestDetailsForDs, GetRequestStatus, PostCspMappingDSApprove, PostHardwareRequestDSAction } from 'API/DS_Wallet/api';
import MainCard from 'ui-component/cards/MainCard';
import { IoCloseCircle } from "react-icons/io5";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ApproveModal from './ApproveMappingModal';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Pagination from '@mui/material/Pagination';


export default function DataTable(props) {
    const [Data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [AlertOpen, setAlertOpen] = useState(false)
    const [AlertMessage, setAlertMessage] = useState("")
    const [AlertType, setAlertType] = useState("success")
    const [SelectedItem, setSelectedItem] = useState(null)
    const [ViewRequest, setViewRequest] = useState(false)
    const [OpenApproveModal, setOpenApproveModal] = useState(false)
    const [Type, setType] = useState(props.data)
    const [HardwareDetails, setHardwareDetails] = useState(null)


    const handleTypeChange = (event) => {
        if (event.target.value === 'select') {
            setType('select')
            props.setData('select')
            setSelectedItem(null)
        }
        else {
            setType(event.target.value)
            props.setData(event.target.value)
            setViewRequest(false)
            setSelectedItem(null)
        }
    }

    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setAlertOpen(true)
    }

    const handleAlertClose = () => {
        setAlertOpen(false)
    }

    const handleViewRequest = () => {
        setViewRequest(true)
    }

    const handleCloseViewRequest = () => {
        setViewRequest(false)
    }

    useEffect(() => {
        if(Type!=='select'){

            GetRequestStatus(setData, setIsLoading, handleAlertOpen, 1,props.status,Type)
        }
    }, [Type])

    function formatDate(dateString) {
        const date = new Date(dateString);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        return `${formattedDate}`;
    }

    function formatTime(dateString) {
        const date = new Date(dateString);
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
        return `${formattedTime}`;
    }


    console.log("Data", Data);

    const handleSelectItem = (item) => {
        setSelectedItem(item);
    }

    const handleOpenApproveModal = () => {
        setOpenApproveModal(true)
    }

    const handleCloseApproveModal = () => {
        setOpenApproveModal(false)
    }

    const handleApproveCSPMapping = () => {
        PostCspMappingDSApprove({ request_id: SelectedItem.request_id }, setIsLoading, handleAlertOpen)
    }

    const handlePostHardwareAction = (action) => {
        PostHardwareRequestDSAction({ request_id: SelectedItem.request_id, action_type: action }, setIsLoading, handleAlertOpen)
    }

    const handlePageChange = (page) => {
        // console.log("pages",page.target.innerText);
        GetRequestStatus(setData, setIsLoading, handleAlertOpen, page.target.innerText)
    }

    useEffect(() => {
        if (Type === 'hardware' && SelectedItem) {
            getHardwareRequestDetailsForDs(SelectedItem.request_id, setHardwareDetails, setIsLoading, handleAlertOpen)
        }
    }, [SelectedItem])

    console.log("herdware", HardwareDetails);


    return (
        <React.Fragment>
            <BackdropLoader open={isLoading} />
            <SnackBar open={AlertOpen} message={AlertMessage} type={AlertType} handleClose={handleAlertClose} />
            <ApproveModal open={OpenApproveModal} handleClose={handleCloseApproveModal} data={SelectedItem} handleApprove={handleApproveCSPMapping} isLoading={isLoading} />
            <Grid item xs={12} mb={1}>
                <Grid container>
                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Request</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={Type ? Type : 'select'}
                                label="Request"
                                onChange={handleTypeChange}
                                inputProps={{
                                    shrink: true
                                }}
                            >
                                <MenuItem value={'select'}>Select</MenuItem>
                                <MenuItem value={'hardware'}>Hardware</MenuItem>
                                <MenuItem value={'csp_mapping'}>CSP Mapping</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            {
                ViewRequest === true ?
                    <Grid container>

                        <Grid item xs={12}>
                            <MainCard>
                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', fontSize: '25px', cursor: 'pointer' }} onClick={() => handleCloseViewRequest()}>
                                    <IoCloseCircle />
                                </Box>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>CSP Name</TableCell>
                                                        <TableCell align="center">CSP code</TableCell>
                                                        <TableCell align="center">Bank</TableCell>
                                                        <TableCell align="center">Location</TableCell>
                                                        <TableCell align="center">Mobile</TableCell>
                                                        <TableCell align="center">Email</TableCell>
                                                        <TableCell align="center">Amount</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {
                                                    SelectedItem && SelectedItem.agent_details?
                                                    <TableBody>
                                                    {SelectedItem.agent_details&&SelectedItem.agent_details.map((row) => (
                                                        <TableRow
                                                            key={row.name}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell component="th" scope="row">
                                                                {row.aadhaar_name}
                                                            </TableCell>
                                                            <TableCell align="center">{row.csp_code}</TableCell>
                                                            <TableCell align="center">{row.bank_name}</TableCell>
                                                            <TableCell align="center">{row.retail_district}</TableCell>
                                                            <TableCell align="center">{row.mobile_number}</TableCell>
                                                            <TableCell align="center">{row.email_address}</TableCell>
                                                            <TableCell align="center">{row.rm_amount?row.rm_amount:row.sh_amount}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                :
                                                <Typography width="100%" variant='h5' sx={{ textAlign: 'center', padding: 2 }}>No Data Found</Typography>
                                                }
                                                
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                                <Stack direction='row' justifyContent="center" gap={2}>
                                    <Button variant='contained' color='success' sx={{visibility:props.status==='pending'?'visible':'hidden'}} onClick={() => handleOpenApproveModal()}>Accept</Button>
                                    <Button variant='outlined' color='error' sx={{visibility:"hidden"}}>Reject</Button>
                                </Stack>
                            </MainCard>
                        </Grid>
                    </Grid>
                    :
                    <Grid container spacing={2}>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <Box sx={{ height: '60vh', overflowY: 'scroll', scrollbarWidth: "none" }}>
                                <Stack gap={2} sx={{ width: '100%' }}>
                                    {
                                        Type === 'csp_mapping' && Data && Data.csp_mapping_data && Array.isArray(Data.csp_mapping_data.data) ?
                                            Data.csp_mapping_data.data.map((item, index) => (
                                                <SubCard onClick={() => handleSelectItem(item)} key={index} title={`Mapping request for ${item.no_of_person}`} sx={{ width: '100%', cursor: 'pointer', height: '100%' }}>
                                                    <table>
                                                        <tr>
                                                            <th>Date</th>
                                                            <td>:</td>
                                                            <td>{formatDate(item.ds_requested_at)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Time</th>
                                                            <td>:</td>
                                                            <td>{formatTime(item.ds_requested_at)}</td>
                                                        </tr>
                                                    </table>
                                                </SubCard>
                                            ))
                                            :
                                            Type === 'hardware' && Data && Data.hardware_data && Array.isArray(Data.hardware_data.data) ?
                                                Data.hardware_data.data.map((item, index) => (
                                                    <SubCard onClick={() => handleSelectItem(item)} key={index} title={`Hardware request`} sx={{ width: '100%', cursor: 'pointer', height: '100%' }}>
                                                        <table>
                                                            <tr>
                                                                <th>Date</th>
                                                                <td>:</td>
                                                                <td>{formatDate(item.ds_requested_at)}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>Time</th>
                                                                <td>:</td>
                                                                <td>{formatTime(item.ds_requested_at)}</td>
                                                            </tr>

                                                        </table>
                                                    </SubCard>
                                                ))
                                                :
                                                null
                                    }
                                </Stack>
                            </Box>

                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            {
                                Type === 'csp_mapping' && SelectedItem ?
                                    <SubCard title={`CSO approved ${SelectedItem.no_of_person} for mapping`} sx={{ width: '100%' }}>
                                        <table>
                                            <tr>
                                                <th>Date</th>
                                                <td>:</td>
                                                <td>{formatDate(SelectedItem.ds_requested_at)}</td>
                                            </tr>
                                            <tr>
                                                <th>Time</th>
                                                <td>:</td>
                                                <td>{formatTime(SelectedItem.ds_requested_at)}</td>
                                            </tr>
                                        </table>
                                        <Stack justifyContent="center" alignItems="center">
                                            <Button onClick={() => handleViewRequest()} sx={{ width: 'fit-content' }} variant='contained' color='secondary'>View Request</Button>
                                        </Stack>
                                    </SubCard>
                                    :
                                    Type === 'hardware' && SelectedItem ?
                                        <SubCard title={`Approval for hardware request`} sx={{ width: '100%' }}>
                                            <table>
                                                <tr>
                                                    <th style={{textAlign:'left'}}>Date</th>
                                                    <td>:</td>
                                                    <td>{formatDate(SelectedItem.ds_requested_at)}</td>
                                                </tr>
                                                <tr>
                                                    <th style={{textAlign:'left'}}>Time</th>
                                                    <td>:</td>
                                                    <td>{formatTime(SelectedItem.ds_requested_at)}</td>
                                                </tr>
                                                <tr>
                                                    <th style={{textAlign:'left'}}>Total amount</th>
                                                    <td>:</td>
                                                    <td>{
                                                        HardwareDetails && HardwareDetails[0].hardware_data && Array.isArray(HardwareDetails[0].hardware_data) ?
                                                        HardwareDetails[0].hardware_data.reduce((total, field) => {
                                                            return total + (field.amount - (field.rm_discount || 0));
                                                          }, 0)
                                                            :
                                                            null
                                                    }
                                                    </td>
                                                </tr>
                                            </table>
                                            <Stack direction='row' gap={1} justifyContent="center" alignItems="center">
                                                <Button  onClick={() => handlePostHardwareAction("approved")} sx={{ width: 'fit-content' ,visibility:props.status==='pending'?'visible':'hidden'}} variant='contained' color='secondary'>Accept</Button>
                                                <Button onClick={() => handlePostHardwareAction("rejected")} sx={{ width: 'fit-content',visibility:props.status==='pending'?'visible':'hidden' }} variant='contained' color='error'>Reject</Button>
                                            </Stack>
                                        </SubCard>
                                        :
                                        null

                            }

                        </Grid>
                        <Grid item>
                            {
                                Data && (Data.hardware_data) && Type === "hardware" ?
                                    <Pagination count={Math.ceil(Data.hardware_data.total_items / Data.hardware_data.page_size)} page={Data.hardware_data.page} onChange={handlePageChange} />
                                    :
                                    Data && Data.csp_mapping_data && Type === "csp_mapping" ?
                                        <Pagination count={Math.ceil(Data.csp_mapping_data.total_items / Data.csp_mapping_data.page_size)} page={Data.csp_mapping_data.page} onChange={handlePageChange} />
                                        :
                                        null
                            }

                        </Grid>
                    </Grid>
            }

        </React.Fragment>
    );
}
